var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment-successful",
    transform: "translate(-112 -274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_686",
    "data-name": "Path 686",
    transform: "translate(112 274)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 1.5 C 24.42185974121094 1.5 20.9515495300293 2.200450897216797 17.68547058105469 3.581890106201172 C 14.5300407409668 4.916519165039062 11.69586944580078 6.827468872070312 9.261669158935547 9.261669158935547 C 6.827468872070312 11.69586944580078 4.916519165039062 14.5300407409668 3.581890106201172 17.68547058105469 C 2.200450897216797 20.9515495300293 1.5 24.42185974121094 1.5 28 C 1.5 31.57814025878906 2.200450897216797 35.0484504699707 3.581890106201172 38.31452941894531 C 4.916519165039062 41.4699592590332 6.827468872070312 44.30413055419922 9.261669158935547 46.73833084106445 C 11.69586944580078 49.17253112792969 14.5300407409668 51.08348083496094 17.68547058105469 52.41810989379883 C 20.9515495300293 53.7995491027832 24.42185974121094 54.5 28 54.5 C 31.57814025878906 54.5 35.0484504699707 53.7995491027832 38.31452941894531 52.41810989379883 C 41.4699592590332 51.08348083496094 44.30413055419922 49.17253112792969 46.73833084106445 46.73833084106445 C 49.17253112792969 44.30413055419922 51.08348083496094 41.4699592590332 52.41810989379883 38.31452941894531 C 53.7995491027832 35.0484504699707 54.5 31.57814025878906 54.5 28 C 54.5 24.42185974121094 53.7995491027832 20.9515495300293 52.41810989379883 17.68547058105469 C 51.08348083496094 14.5300407409668 49.17253112792969 11.69586944580078 46.73833084106445 9.261669158935547 C 44.30413055419922 6.827468872070312 41.4699592590332 4.916519165039062 38.31452941894531 3.581890106201172 C 35.0484504699707 2.200450897216797 31.57814025878906 1.5 28 1.5 M 28 0 C 43.46397018432617 0 56 12.53602981567383 56 28 C 56 43.46397018432617 43.46397018432617 56 28 56 C 12.53602981567383 56 0 43.46397018432617 0 28 C 0 12.53602981567383 12.53602981567383 0 28 0 Z",
    stroke: "none",
    fill: "#2ec973"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check_2_",
    "data-name": "check (2)",
    d: "M24.71,6,10.472,20.238,4,13.766",
    transform: "translate(125.645 289.381)",
    fill: "none",
    stroke: "#2ec973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIcon);
export default __webpack_public_path__ + "static/media/payment-success-icon.1e720ded270324116d819fc66f068a9c.svg";
export { ForwardRef as ReactComponent };